import { passosInfluencer } from '../../../mocks/influencers-parceiros';

export default function ComoFuncionaInfluencer() {
  return (
    <section className="py-24 bg-gradient-to-br from-amber-50 via-white to-rose-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-white rounded-full mb-6 border border-amber-200">
            <i className="ri-lightbulb-line text-amber-600"></i>
            <span className="text-sm font-semibold text-amber-800 tracking-wide">PROCESSO SIMPLES</span>
          </div>
          <h2 className="font-playfair text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Como Funciona a
            <span className="block text-amber-600 mt-2">Parceria</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Em 4 passos simples você se torna uma parceira oficial e começa a transformar vidas
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connection Lines */}
          <div className="hidden lg:block absolute top-24 left-0 right-0 h-1 bg-gradient-to-r from-amber-200 via-amber-300 to-amber-200"></div>

          {passosInfluencer.map((passo, index) => (
            <div key={index} className="relative">
              {/* Step Card */}
              <div className="bg-white p-8 rounded-2xl border-2 border-amber-100 hover:shadow-2xl hover:scale-105 transition-all duration-300 h-full">
                {/* Number Badge */}
                <div className="relative z-10 w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl flex items-center justify-center mb-6 mx-auto">
                  <span className="font-playfair text-2xl font-bold text-white">{passo.numero}</span>
                </div>

                {/* Content */}
                <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-4 text-center">
                  {passo.titulo}
                </h3>
                <p className="text-gray-600 leading-relaxed text-center">
                  {passo.descricao}
                </p>
              </div>

              {/* Arrow (desktop only) */}
              {index < passosInfluencer.length - 1 && (
                <div className="hidden lg:block absolute top-24 -right-4 z-20">
                  <i className="ri-arrow-right-line text-3xl text-amber-600"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <a 
            href="#formulario"
            className="inline-flex items-center gap-3 px-10 py-5 bg-gradient-to-r from-amber-600 to-amber-500 text-white rounded-full font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span>Começar Agora</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}